import { VisitorIdsParams } from 'utils/commonTypes';
import {
  GET_DRIVER_ID_REQUEST,
  GET_DRIVER_ID_SUCCESS,
  GET_DRIVER_DATA_REQUEST,
  GET_DRIVER_DATA_SUCCESS,
  GET_DRIVER_ERROR,
  ADD_TO_BLACKLIST_REQUEST,
  ADD_TO_BLACKLIST_SUCCESS,
  ADD_TO_BLACKLIST_ERROR,
  CLEAR_DRIVER_FIELD,
  GET_DRIVER_AND_TRANSPORT_DATA_REQUEST,
} from './constants';

export const getDrIdReguest = (url: string, field: string, tripValue: any) => ({
  type: GET_DRIVER_ID_REQUEST,
  payload: url,
  field,
  tripValue,
});

export const getDrIdSuccess = (id: string) => ({
  type: GET_DRIVER_ID_SUCCESS,
  payload: id,
});

export const getDrIdError = (error: Error | null) => ({
  type: GET_DRIVER_ERROR,
  payload: error,
});

export const getDrDataReguest = (id: string) => ({
  type: GET_DRIVER_DATA_REQUEST,
  payload: id,
});

export const getDriverAndTransportDataRequest = (params: VisitorIdsParams) => ({
  type: GET_DRIVER_AND_TRANSPORT_DATA_REQUEST,
  payload: params,
});

export const getDrDataSuccess = () => ({
  type: GET_DRIVER_DATA_SUCCESS,
});

export const getDrDataError = (error: Error | null) => ({
  type: GET_DRIVER_ERROR,
  payload: error,
});

export const clearDrDataField = () => ({
  type: CLEAR_DRIVER_FIELD,
});

export const addToBlackListReguest = (data: any) => ({
  type: ADD_TO_BLACKLIST_REQUEST,
  payload: data,
});

export const addToBlackListSuccess = () => ({
  type: ADD_TO_BLACKLIST_SUCCESS,
});

export const addToBlackListError = (error: Error | null) => ({
  type: ADD_TO_BLACKLIST_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof clearDrDataField>
  | ReturnType<typeof getDrIdReguest>
  | ReturnType<typeof getDrIdSuccess>
  | ReturnType<typeof getDrIdError>
  | ReturnType<typeof getDrDataReguest>
  | ReturnType<typeof getDrDataSuccess>
  | ReturnType<typeof getDrDataError>
  | ReturnType<typeof addToBlackListReguest>
  | ReturnType<typeof addToBlackListSuccess>
  | ReturnType<typeof addToBlackListError>
  | ReturnType<typeof getDriverAndTransportDataRequest>;
